import React from 'react'
import PropTypes from 'prop-types'

export default function CheckboxRenderer (props) {
  const onClick = (event) => {
    if (!props.colDef.editable) {
      return (false)
    }

    const colId = props.column.colId

    props.node.setDataValue(colId, event.target.checked)
  }

  return (<input type="checkbox" disabled={!props.colDef.editable} checked={props.value} onChange={onClick} />)
}

CheckboxRenderer.propTypes = {
  value: PropTypes.bool,
  node: PropTypes.object,
  column: PropTypes.object,
  colDef: PropTypes.object
}
